import { useQuery } from 'react-query';
import eventMetadataApi from '../api/eventMetadata.api';
import { DefaultErrorMessage } from '../displayStrings';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';

export const useEventMetadata = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  return useQuery(['eventMetadata', companyId], () => eventMetadataApi.getMetadata(companyId), {
    staleTime: 5 * 60 * 1000,
    onError: () => {
      showToast({
        title: 'Could not retrieve event metadata',
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
